import { calculateTotal } from '@calculations/price/utilities/total';
import { SnapSuggestionStatus } from '@snap-types/models/common';
import { Decimal } from '@snap-types/types/decimal';
import { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

import {
  getQuoteLineOrThrow,
  getQuotePriceOrThrow,
} from '../../utilities/action-guards';
import { OnContributionMarginChangeInput } from '../types';
import { buildStrategyCalculations } from '../utilities/build-strategy-calculations';

export function onContributionMarginChange(
  state: WritableQuoteBuilderStateType,
  params: {
    quoteLineUuid: string;
    quotePriceUuid: string;
    contributionMargin: Decimal;
  },
) {
  const quoteLine = getQuoteLineOrThrow(state, params.quoteLineUuid);
  const quotePrice = getQuotePriceOrThrow(
    state,
    params.quoteLineUuid,
    params.quotePriceUuid,
  );
  const { priceStrategy } = quoteLine;

  const inputs = {
    state,
    quoteLine,
    quotePrice,
    contributionMargin: params.contributionMargin,
  } satisfies OnContributionMarginChangeInput;

  const calculation = buildStrategyCalculations('onContributionMarginChange')[
    priceStrategy
  ];

  if (!calculation) {
    console.error(
      'No contribution margin calculation function found for price strategy',
      priceStrategy,
    );
    return;
  }

  const output = calculation(inputs);

  if (output.status === 'failure') {
    // @TODO(NT): Our store should be integrated with toast notifications
    console.error('Failed to calculate price', output.reason);
    return;
  }

  quotePrice.contributionMargin = params.contributionMargin;
  quotePrice.calculatedContributionMargin = null;
  quotePrice.userContributionMargin = params.contributionMargin;

  if (output.status === 'success') {
    quotePrice.unitPrice = output.unitPrice;
    quotePrice.calculatedUnitPrice = output.unitPrice;
    quotePrice.userUnitPrice = null;
    quotePrice.totalPrice = calculateTotal(
      output.unitPrice,
      quotePrice.quantity,
    );
    quotePrice.suggestedPriceStatus = SnapSuggestionStatus.REJECTED;
  }
  quoteLine.automatable = false;
  if (quotePrice.suggestedPriceStatus === SnapSuggestionStatus.REJECTED) {
    quoteLine.suggestedPricesStatus = SnapSuggestionStatus.REJECTED;
  }
}
